<template>
  <div
    class="d-flex flex-column flex-grow-1 py-sm-4"
  >
    <div class="py-2">
      <b-container>
        <h4 class="mb-3">
          Setup Multi-Factor Authentication
        </h4>

        <p>Have your phone ready with Google Authenticator, Microsoft Authenticator or Authy installed. The guide below uses Google Authenticator.</p>

        <SoftwareMFA @success="onSuccess" />
      </b-container>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import SoftwareMFA from '@/components/account/SoftwareMFA.vue'
import pageTrackingMixin from '@/mixins/ms-clarity-mixin'
import onboardingMixin from '@/mixins/onboarding.mixin'

export default {
  name: 'OnboardingSoftwareMFA',

  onboardingStep: 'mfa',

  components: {
    SoftwareMFA,
  },

  mixins: [pageTrackingMixin, onboardingMixin],

  computed: {
    ...mapGetters('auth', [
      'accountOnboardingStatus'
    ]),
  },

  methods: {
    onSuccess() {
      this.$router.push({
        name: 'Dashboard'
      })
    }
  },
}
</script>
<style lang="">
  
</style>
